import React from 'react';
import ActivityRow from './ActivityRow';
import EmptyState from './EmptyState';
import { fmtDateISO, safeParseDate } from '../utils';

export default function TimelineView({ timelineItems, openDetail }) {
  if (timelineItems.length === 0) {
    return <EmptyState title="No activities" subtitle="Try enabling more tags or changing range." />;
  }
  let lastDay = '';
  return (
    <div className="timeline">
      {timelineItems.map((a) => {
        const d = safeParseDate(a.at);
        const key = fmtDateISO(new Date(d.getFullYear(), d.getMonth(), d.getDate()));
        const newGroup = key !== lastDay;
        lastDay = key;
        return (
          <React.Fragment key={a.id}>
            {newGroup ? (
              <div className="tGroup">
                <div className="tDate">
                  <span className="tDateDot" />
                  <span className="tDateTxt">{key}</span>
                  <span className="tDateCount">{timelineItems.filter((x) => fmtDateISO(safeParseDate(x.at)) === key).length}</span>
                </div>
              </div>
            ) : null}
            <ActivityRow a={a} onView={openDetail} />
          </React.Fragment>
        );
      })}
    </div>
  );
}
